import { Observable } from 'rxjs';
import { Guid, PagedResults } from '../../core';
import { InjectionToken } from '../../injection';

import { Notification } from '../data/notification.do';
import { PushPlatform } from '../other/push-platform.enum';

export interface INotificationsQueryParameters {
  organizationId: Guid;
  fromDate?: Date;
  toDate?: Date;
  page?: number;
  pageSize?: number;
}

export interface INotificationSubscriptionOptions {
  // Device token to use in subscription.
  deviceToken: string;
  // List for organization IDs to subscribe to.
  organizationIds: Guid[];
  // The platform used for sending and retrieving push notifications.
  pushPlatform: PushPlatform;
}

export interface INotificationsService {
  getNotifications(queryParameters: INotificationsQueryParameters): Observable<PagedResults<Notification>>;

  subscribe(organizationIds: Guid[]): Observable<void>;

  unsubscribe(organizationIds: Guid[]): Observable<void>;
}

export const NOTIFICATIONS_SERVICE: InjectionToken<INotificationsService>
  = new InjectionToken<INotificationsService>('NOTIFICATIONS_SERVICE');
